/**
 * Cloudflare Turnstile integration for Frappe login page.
 * Only activates when Turnstile is enabled in Turnstile Settings.
 */
(function () {
	"use strict";

	if (window.location.pathname !== "/login") return;

	var turnstile_site_key = null;
	var turnstile_token = null;
	var turnstile_widget_id = null;

	// Fetch site key asynchronously and then set everything up
	fetch("/api/method/eternal_support.utils.turnstile.get_turnstile_site_key", {
		method: "GET",
		headers: { Accept: "application/json" },
	})
		.then(function (response) {
			return response.json();
		})
		.then(function (data) {
			if (data.message && data.message.enabled && data.message.site_key) {
				turnstile_site_key = data.message.site_key;
				setup_turnstile();
			}
		})
		.catch(function () {
			// Silently fail — turnstile won't be active
		});

	function setup_turnstile() {
		// Load Cloudflare Turnstile script
		var script = document.createElement("script");
		script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
		script.async = true;
		document.head.appendChild(script);

		// Wait for login button + login.call + turnstile API, then init
		var poll = setInterval(function () {
			var btn = document.querySelector(".btn-login");
			if (btn && window.login && window.login.call) {
				clearInterval(poll);
				inject_widget(btn);
				override_login(btn);
			}
		}, 150);

		// Stop polling after 15s
		setTimeout(function () {
			clearInterval(poll);
		}, 15000);
	}

	function inject_widget(login_btn) {
		if (document.getElementById("turnstile-container")) return;

		var container = document.createElement("div");
		container.id = "turnstile-container";
		container.style.cssText = "display:flex;justify-content:center;margin:15px 0;";

		var actions_div = login_btn.closest(".page-card-actions");
		if (actions_div) {
			actions_div.parentNode.insertBefore(container, actions_div);
		} else {
			login_btn.parentNode.insertBefore(container, login_btn);
		}

		// Render widget when turnstile API is ready
		var tw = setInterval(function () {
			if (window.turnstile) {
				clearInterval(tw);
				turnstile_widget_id = window.turnstile.render("#turnstile-container", {
					sitekey: turnstile_site_key,
					callback: function (token) {
						turnstile_token = token;
					},
					"expired-callback": function () {
						turnstile_token = null;
					},
					"error-callback": function () {
						turnstile_token = null;
					},
					theme: "auto",
				});
			}
		}, 150);
	}

	function override_login(login_btn) {
		var original_call = window.login.call;

		window.login.call = function (args, callback, url) {
			// Only intercept the initial login cmd, not 2FA verification
			if (args && args.cmd === "login") {
				// Skip turnstile check for 2FA OTP submissions —
				// these have tmp_id or otp fields set by Frappe's 2FA flow
				var is_2fa = args.tmp_id || args.otp;

				if (!is_2fa) {
					// Check if the widget container still exists in the DOM
					var container_exists = document.getElementById("turnstile-container");

					if (!container_exists) {
						// Widget was destroyed (e.g. page re-rendered), allow through
						return original_call.apply(this, arguments);
					}

					if (!turnstile_token) {
						frappe.show_alert(
							{
								message: __(
									"Please complete the CAPTCHA verification before logging in."
								),
								indicator: "orange",
							},
							5
						);
						login_btn.textContent = "Login";
						login_btn.disabled = false;
						return false;
					}

					// Server-side verify
					var verified = verify_token(turnstile_token);
					if (!verified) {
						reset_widget();
						login_btn.textContent = "Login";
						login_btn.disabled = false;
						return false;
					}
				}
			}

			return original_call.apply(this, arguments);
		};
	}

	function reset_widget() {
		// Safely reset widget only if it still exists in the DOM
		if (
			turnstile_widget_id !== null &&
			window.turnstile &&
			document.getElementById("turnstile-container")
		) {
			try {
				window.turnstile.reset(turnstile_widget_id);
			} catch (e) {
				// Widget may have been removed from DOM, ignore
			}
		}
		turnstile_token = null;
	}

	function verify_token(token) {
		var csrf = (window.frappe && window.frappe.csrf_token) || get_cookie_csrf() || "None";

		var xhr = new XMLHttpRequest();
		xhr.open(
			"POST",
			"/api/method/eternal_support.utils.turnstile.verify_captcha_for_login",
			false
		);
		xhr.setRequestHeader("Content-Type", "application/json");
		xhr.setRequestHeader("Accept", "application/json");
		xhr.setRequestHeader("X-Frappe-CSRF-Token", csrf);

		try {
			xhr.send(JSON.stringify({ turnstile_token: token }));
			if (xhr.status === 200) {
				var r = JSON.parse(xhr.responseText);
				return r.message && r.message.status === "ok";
			}
			try {
				var err = JSON.parse(xhr.responseText);
				if (err._server_messages) {
					var msgs = JSON.parse(err._server_messages);
					var msg = JSON.parse(msgs[0]).message;
					frappe.show_alert({ message: msg, indicator: "red" }, 5);
				}
			} catch (e) {
				frappe.show_alert(
					{
						message: __("CAPTCHA verification failed. Please try again."),
						indicator: "red",
					},
					5
				);
			}
			return false;
		} catch (e) {
			frappe.show_alert(
				{
					message: __("CAPTCHA verification failed. Please try again."),
					indicator: "red",
				},
				5
			);
			return false;
		}
	}

	function get_cookie_csrf() {
		var match = document.cookie.match(/csrf_token=([^;]+)/);
		return match ? decodeURIComponent(match[1]) : null;
	}
})();
